import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ImmoNewProject } from 'src/app/model/project/immo-new-project';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import { ModalService } from 'src/app/services/modal.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { SubProjectImmoCompleted } from '../../../../model/project/sub-project-immo-completed';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';

@Component({
  selector: 'completed-immo-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class CompletedImmoOverviewComponent
  extends AbstractImmoOverviewComponent<SubProjectImmoCompleted>
  implements OnInit
{
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected modalService: ModalService,
    protected _lightbox: Lightbox,
    protected router: Router
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.requestAdjustmentTooltipSuffix = 'activeren';
  }

  public override openTour(subProject: SubProjectImmoCompleted): void {
    throw new Error('Method not implemented.');
  }
  public override copyProjectId(subProject: SubProjectImmoCompleted): void {
    throw new Error('Method not implemented.');
  }
  protected override getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected override getLocalStorageKey(): string {
    return 'CompletedImmoOverviewComponent';
  }

  protected override initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'execution',
      'installer',
      'customerName',
      'address',
      'kind',
      'measurements',
      'type',
      'requestAdjustmentButtons',
      'photoOnlyIpBoard',
      'displayStatus',
    ];
  }

  protected override initSortSettings(): void {
    this.sortColumn = 'currentExecutionDate';
    this.sortAscending = false;
  }

  protected override fetchItems() {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoCompleted(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.countChange.emit(this.totalItems);
        this.parseFetchedItems(res.items);
        this.items = res.items;
      })
      .finally(() => (this.loading = false));
  }

  private parseFetchedItems(items: SubProjectImmoCompleted[]): void {
    items.forEach((item) => {
      if (
        item.project != null &&
        CollectionHelper.isPopulated(item.project.ipBoards)
      ) {
        item.project.firstIpBoard = item.project.ipBoards[0];
      }

      item.statusClass =
        item.project != null && item.project.collaborative ? 'collab' : 'new';
    });
  }

  public override openProject(subProject: SubProjectImmoCompleted): void {
    this.router.navigate([
      '/job',
      subProject.project == null ? null : subProject.project.id,
      subProject.id,
    ]);
  }

  public requestSoldRented(project: ImmoNewProject): void {
    this.router.navigateByUrl(
      `/klant-opdracht-verkocht-verhuurd/${project.id}`
    );
  }

  public requestAdjustment(project: ImmoNewProject): void {
    this.router.navigateByUrl(`/klant-opdracht-aanpassing/${project.id}`);
  }

  public requestRepo(project: ImmoNewProject): void {
    this.router.navigateByUrl(`/klant-opdracht-weghalen/${project.id}`);
  }
}
